import { Controller } from 'libraries/front-end-core/core/Router'
import { LEGISLATION_CATEGORIES } from 'constants/controllers'
import Main from 'pages/legislationcategories/Main'
import Header from './Header'

export default new Controller({
  name: LEGISLATION_CATEGORIES,
  route: 'legislation/folder',
  controller (
    Router,
    {
      url: pageId,
      scrollMain,
      pageView,
      pageData,
      params: { path = null },
      previousPageId,
      query
    },
    render
  ) {
    render(
      { Main, Header },
      { act: path, scrollMain, query },
      {
        pageId,
        searchType: 'legislation',
        className: 'legislation legislation-accordion-namespace'
      }
    )

    return pageId
  }
})
